import { Box, Text } from "theme-ui";
import * as React from 'react';
export default {
  Box,
  Text,
  React
};